document.addEventListener("DOMContentLoaded", () => {
  const lines = document.querySelectorAll('.hp-timeline__progress-item');
  const stickyElement = document.querySelector('.hp-timeline__media');
  const stickyHeight = stickyElement.offsetHeight;
  const timeline = gsap.timeline();

  stickyElement.style.setProperty('--sticky-height', `${stickyHeight}px`);

  lines.forEach((line, index) => {
    timeline.to(line, {
      "--timeline-height": index === lines.length - 1 ? "initial" : "100%",
      scrollTrigger: {
        trigger: line,
        start: 'top center',
        end: index === lines.length - 1 ? 'bottom bottom' : 'bottom center',
        scrub: true,
        onEnter: () => gsap.to(line, { opacity: 1, duration: 0.5 }),
        onLeaveBack: () => gsap.to(line, { opacity: 0, duration: 0.5 })
      }
    });
  });

  const intervalTimes = 6;
  let videoItems = document.querySelectorAll('video.hp-timeline__pin');
  let counter = 0;
  let flag = false;
  let interval = setInterval(() => {
    counter++;
    videoItems.forEach(item => {
      if (item.paused) {
        item.play();

        flag = true;
      }
    })

    if (flag || counter >= intervalTimes) {
      clearInterval(interval);
    }
  }, 500);
});
